//     							                          //
//  Program: HomeSharingSidebar.jsx                       //
//  Application: Property                                 //
//  Option: common component HomeSharing Sidebar          //
//  Developer: NP 		                                  //
//  Date: 2022-04-02                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { Link } from "react-router-dom";

class HomeSharingSidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pathname: window.location.pathname,
      property_slug: sessionStorage.getItem("property_slug") ? sessionStorage.getItem("property_slug") : "",
    };
  }

  isPathActive(path){
    return window.location.pathname.includes(path);
  }

  render() {
    return (
        <nav className="nav nav-pills flex-column pd-r-8">
                <ul>
                    <li>
                        <ul>
                            <li>
                            <Link
                                className={
                                  this.isPathActive("homesharing-listings")
                                  ? "nav-link active"
                                  : "nav-link"
                                }
                                data-toggle="tab"
                                to={"/properties/view/" + (this.props.property_slug ? this.props.property_slug : this.state.property_slug ) + "/homesharing-listings"}
                            >
                                Listings
                            </Link>
                            </li>
                            <li>
                            <Link
                                className={
                                  this.isPathActive("reservations")
                                  ? "nav-link active"
                                  : "nav-link"
                                }
                                data-toggle="tab"
                                to={"/properties/view/" + (this.props.property_slug ? this.props.property_slug : this.state.property_slug ) + "/reservations"}
                            >
                                Reservations
                            </Link>
                            </li>
                            <li>
                            <Link
                                className={
                                  this.isPathActive("guests")
                                  ? "nav-link active"
                                  : "nav-link"
                                }
                                data-toggle="tab"
                                to={"/properties/view/" + (this.props.property_slug ? this.props.property_slug : this.state.property_slug ) + "/guests"}
                            >
                                Guests
                            </Link>
                            </li>
                            <li>
                            <Link
                                className={
                                  this.isPathActive("homesharing-payments")
                                  ? "nav-link active"
                                  : "nav-link"
                                }
                                data-toggle="tab"
                                to={"/properties/view/" + (this.props.property_slug ? this.props.property_slug : this.state.property_slug ) + "/homesharing-payments"}
                            >
                                Payments
                            </Link>
                            </li>
                        </ul>
                    </li>
                </ul>
        </nav>
    );
  }
}
export default HomeSharingSidebar;